module.exports = Object.freeze({
    SYSTEM_NAME: "Hệ thống quản trị điện tử",
    TITLE: "Hãy chọn phân hệ làm việc",
    LOGIN: "Đăng nhập",
    HUMAN_RESOURCE: "NHÂN SỰ",
    HUMAN_RESOURCE_INTRO: "Thông tin nhân sự, chế độ, tuyển dụng...",
    PROPERTY_MAINTENANCE: "BẢO TRÌ TÀI SẢN",
    PROPERTY_MAINTENANCE_INTRO: "Bảo trì, sửa chữa theo kế hoạch/đột xuất...",
    ELECTRIC_OFFICE: "VĂN PHÒNG ĐIỆN TỬ",
    ELECTRIC_OFFICE_INTRO: "Quản lý công văn, ban hành công văn, điều hành công ty...",
    BUSINESS_ADMINISTRATION:"QUẢN TRỊ KINH DOANH",
    BUSINESS_ADMINISTRATION_INTRO:"Maketing, hợp đồng cung cấp nước...",
    CLIENT: "KHÁCH HÀNG",
    CLIENT_INTRO: "Chăm sóc khách hàng, thông tin khách hàng...",
    ACCOUNTANT: "KẾ TOÁN",
    ACCOUNTANT_INTRO: "Công nợ, tài chính, lương...",
    SYSTEM: "HỆ THỐNG",
    USER_INFORMATION: "Thông tin người dùng",
    ACCOUNT: "Người dùng",
    HOME_PAGE: 'Về trang chủ',
    ABOUT_US: 'Trang giới thiệu',
    LOG_OUT: 'Đăng xuất',
});